import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {EMPTY, Observable, of} from 'rxjs';
import {catchError, first, mergeMap} from 'rxjs/operators';
import {TixxSelectService} from '../services/tixx-select/tixx-select.service';
import {NotificationType} from '../enum/notification.enum';
import {Club, Lottery} from '../models';
import {DefaultNotificationService, StorageService} from '../services';
import {CustomerOverviewTranslationsService} from 'src/app/shared/translations';

/**
 * Checks whether we have selected the lottery yet, if not this resolver will fetch it instead.
 */
@UntilDestroy()
@Injectable()
export class TixxSelectResolver implements OnDestroy {
  private selectedClub: Club;

  constructor(
    private tixxSelectService: TixxSelectService,
    private router: Router,
    private storage: StorageService,
    private notificationService: DefaultNotificationService,
    private customerOverviewTranslations: CustomerOverviewTranslationsService
  ) {
    this.storage.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe((club: Club) => this.selectedClub = club);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Checks whether the user has selected a club-overview.
   */
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
    if (this.tixxSelectService.selectedLottery.value === null) {
      return this.tixxSelectService.getLottery(route.params['id']).pipe(
        first(),
        catchError(error => {
          this.notificationService.showNotification({
            type: NotificationType.ALERT,
            message: this.customerOverviewTranslations.i18nErrorLotteryNotExisting
          });
          this.router.navigate([`/club/${this.selectedClub.id}`]);
          return EMPTY;
        }),
        mergeMap((lottery: Lottery) => {
          const clubPath = `/api/l/organizers/${this.selectedClub.id}`;
          if (lottery) {
            if (clubPath === lottery.organizer['@id']) {
              this.tixxSelectService.setSelectedLottery(lottery);
              return of(lottery);
            } else {
              this.notificationService.showNotification({
                type: NotificationType.ALERT,
                message: this.customerOverviewTranslations.i18nErrorLotteryNotExisting
              });
              this.router.navigate([`/club/${this.selectedClub.id}`]);
              return EMPTY;
            }
          } else {
            this.notificationService.showNotification({
              type: NotificationType.ALERT,
              message: this.customerOverviewTranslations.i18nErrorLotteryNotExisting
            });
            this.router.navigate([`/club/${this.selectedClub.id}`]);
            return EMPTY;
          }
        }));
    }
  }
}
